import SecondaryCharacter from "../actors/SecondaryCharacter";
import common from "../common";

export default class CharacterSelection {
    constructor() {
        this._characterList = [];

        this.createNewCharacter("Tin Man", P3.assets.texture('char_tinman'));
        this.createNewCharacter("Scarecrow", P3.assets.texture('char_scarecrow'));
        this.createNewCharacter("Lion", P3.assets.texture('char_lion'));
        this.createNewCharacter("Ozma", P3.assets.texture('char_ozma'));

        this.selectRandomCharacter();
    }

    selectRandomCharacter() {
        common.selectedCharacter = common.randomSelection(this._characterList);
    }

    createNewCharacter(name, texture) {
        this._characterList.push(new SecondaryCharacter(name, common.selectedRecipe.request, texture));
    }
}